import { Component } from '@angular/core';
import { Router, ActivatedRoute, } from '@angular/router';
import { AppSettingsService, TokenService, EndpointsService } from './services';
import { Http, Headers } from '@angular/http';
import { LogoutService } from './services/logout.service';

@Component({
    template: ``
})
export class AutoLoginComponent {
    constructor(activatedRoute: ActivatedRoute, router: Router, appSettingsService: AppSettingsService, tokenService: TokenService, endpointsService: EndpointsService, http: Http, logoutService: LogoutService) {
        let refreshToken = tokenService.getRefreshToken();
        if (!refreshToken) {
            logoutService.logout();
        }

        let params: string = 'refresh_token=' + refreshToken + '&grant_type=refresh_token';
        let headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return http.post(endpointsService.ACCOUNT_LOGIN, params, { headers: headers }).subscribe(
            response => {
                let token = response.json() && response.json().access_token;
                if (token) {
                    tokenService.setBearerToken(token)
                    tokenService.setRefreshToken(response.json().refresh_token);
                    tokenService.setBearerTokenExpiration(response.json()[".expires"]);
                    let returnUrl = activatedRoute.snapshot.params['returnUrl'];
                    if (returnUrl)
                        router.navigate([returnUrl]);
                    else
                        router.navigate([appSettingsService.LoginPath]);
                } else {
                    logoutService.logout();
                }
            },
            () => {
                logoutService.connectionTimeOut();
            }
        )
    }
}


// WEBPACK FOOTER //
// ./src/app/core/auto-login.component.ts